import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';

export type RealtimeUpdate = {
  title: string;
  description: string;
  type: 'notification' | 'modal';
  id: string;
};

const initState = Map({
  realtimeUpdates: [],
});

export default function realtimeUpdateReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case actions.REALTIME_UPDATES_RECIEVED:
      if (action.payload) {
        return state.set('realtimeUpdates', state.get('realtimeUpdates').concat(action.payload));
      }
      return state;

    case actions.REMOVE_REALTIME_UPDATE:
      const id = action.payload;
      return state.set(
        'realtimeUpdates',
        state
          .get('realtimeUpdates')
          .filter((realtimeUpdate: RealtimeUpdate) => realtimeUpdate.id !== id)
      );

    default:
      return state;
  }
}
